var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11466 17.1152C6.86399 17.1152 6.65382 17.0305 6.48416 16.861C6.31466 16.6915 6.22991 16.4814 6.22991 16.2308V14.7308H18.6049L18.9222 15.048V6H20.4222C20.6728 6 20.8829 6.08475 21.0524 6.25425C21.2221 6.42392 21.3069 6.634 21.3069 6.8845V20.6538L17.7684 17.1152H7.11466ZM2.69141 16.2693V3.38475C2.69141 3.13408 2.77624 2.92392 2.94591 2.75425C3.11541 2.58475 3.32549 2.5 3.57616 2.5H16.0377C16.2883 2.5 16.4984 2.58475 16.6679 2.75425C16.8374 2.92392 16.9222 3.13408 16.9222 3.38475V11.8463C16.9222 12.0968 16.8374 12.3068 16.6679 12.4765C16.4984 12.646 16.2883 12.7308 16.0377 12.7308H6.22991L2.69141 16.2693Z",
    fill: "#4D4D53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultingIcon);
export default __webpack_public_path__ + "static/media/consulting-icon.3bc610246a16982b3f42cacb098b7011.svg";
export { ForwardRef as ReactComponent };